import { MouseEventHandler } from "react";

export type NodesType = {
  [key: string]: {
    shape: JSX.Element;
    shapeId: string;
    typeText: string;
  };
};



export const DefaultEdgeType = (
  <symbol viewBox="0 0 50 50" id="defaultEdge">
    <circle cx="25" cy="25" r="12" fill="currentColor" />
  </symbol>
);

const GeneratorShape = (
  <symbol viewBox="0 0 120 120" id="generator" width="120" height="120">
    <circle cx="60" cy="60" r="60" />
  </symbol>
);

const ProcessorShape = (
  <symbol viewBox="0 0 100 100" id="processor" width="100" height="100">
    <rect width="100" height="100" />
  </symbol>
);

const ProcessorShapeTest = (width: string, id: string): JSX.Element => {
  return (
    <symbol viewBox={"0 0 " + width + " 100"} id={id} width={width} height="100">
      <rect width={width} height="100" />
    </symbol>
  );
}

const MergerShape = (
  <symbol viewBox="-27 0 154 154" id="merger" width="154" height="154">
    <rect transform="translate(50) rotate(45)" width="109" height="109" />
  </symbol>
);

export const nodeShapes = {
  processor: ProcessorShape,
  processorTest: ProcessorShapeTest,
  generator: GeneratorShape,
  merger: MergerShape,
};

const graphConfig = {
  edgeTypes: {
    emptyEdge: {
      shape: DefaultEdgeType,
      shapeId: '#defaultEdge',
    },
  },
  nodeSubtypes: {},
};

export const NODE_KEY = 'id';

export default graphConfig;
